"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectState = void 0;
exports.ProjectState = {
    Creating: "creating",
    Default: "default",
    Converting: "converting",
    InQueue: "in_queue",
};
